import React from "react"

import SEOHelmet from '../../../../components/Layout/SEOHelmet'
import FTPServer from "../../../../components/Products/Software/Videos/video-synology-add-camera"
import Footer from "../../../../components/Layout/footer"

const seodata = {
  title: 'Add Cameras to a Synology Disk Station',
  description: 'Use your Synology or QNAP NAS to manage all your cameras and their video recordings. Or add them to your home automation system.',
  image: '/images/Search/P_SearchThumb_Products.png'
};

// export default (props) => (

function SynologyAdd(props) {
    return (
            
    <React.Fragment>
      <SEOHelmet title={seodata.title} description={seodata.description} image={seodata.image} location={props.location.pathname} />
      <h1 id="introduction" style={{ marginTop: 0 }}>
        Hinzufügen einer INSTAR IP Kamera zur Synology Surveillance Station 7.x
      </h1>
      <FTPServer />
      <br />
      <br />
      <Footer
        previousTitle="Other Platforms"
        previousLink="/fr/Software/Other_Platforms/"
        nextTitle="Synology"
        nextLink="/fr/Software/Other_Platforms/Synology/" />
    </React.Fragment>
  )
}

export default SynologyAdd